// vm-pagination.js
import * as Sentry from '@sentry/browser';
import { LitElement, html } from 'lit';
import Styles from './vm-kol-profile-page.scss';
import { fetchRequest } from 'Utils/api-fetch-request';

export default class VmKolProfilePage extends LitElement {
    static API_BASE_URL = '/api/kol/';
    static styles = Styles;

    static properties = {
        kolUuid: { type: String },
        kolProfileData: { state: true },
        dataLoaded: { state: true },
    };

    constructor() {
        super();

        const pageUrl = window.location.pathname;
        const match = pageUrl.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);

        this.kolUuid = match?.[0] ?? null;
        this.dataLoaded = false;
    }

    async fetchKolProfileData() {
        const url = `${this.constructor.API_BASE_URL}${this.kolUuid}/`;

        try {
            this.kolProfileData = await fetchRequest(url);
            this.dataLoaded = true;
        } catch (error) {
            Sentry.captureException(error);
        }
    }

    async connectedCallback() {
        super.connectedCallback();
        await this.fetchKolProfileData();
    }

    render() {
        return html`
            <div class="kol-profile">
                ${this.dataLoaded
                    ? html`
                          <vm-kol-profile-page-header
                              .kolProfileData=${this.kolProfileData}
                          ></vm-kol-profile-page-header>
                      `
                    : html` <vm-loading-spinner size="3"></vm-loading-spinner> `}

                <div class="kol-profile__content-wrap">
                    <vm-kol-profile-page-video-list
                        .kolUuid=${this.kolUuid}
                        .kolProfileStatistics=${this.kolProfileData?.statistics ?? {}}
                    ></vm-kol-profile-page-video-list>
                </div>
            </div>
        `;
    }
}
